import { render, staticRenderFns } from "./Swaps.vue?vue&type=template&id=3c95f75a"
import script from "./Swaps.vue?vue&type=script&lang=ts"
export * from "./Swaps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports